import { TFunction } from 'i18next';
import { ReportColumnConfig } from 'modules/reports/types';
import { formatDateSafe } from 'modules/reports/utils/formatDateSafe';
import { formatSafeValue } from 'modules/reports/utils/formatSafeValue';

import { ParsedIneligibleReport } from './types';

export const getIneligibleReportColumns = (
  t: TFunction
): ReportColumnConfig<ParsedIneligibleReport>[] => [
  // --- Basic Info ---
  {
    key: 'id',
    label: t('id'),
    getValue: (item) => item.id || '',
  },
  {
    key: 'createdAt',
    label: t('createdAt'),
    getValue: (item) => formatDateSafe(item.createdAt),
  },

  // --- Owner Data ---
  {
    key: 'ownerEmail',
    label: t('ownerEmail'),
    getValue: (item) => item.ownerData?.email || '',
  },
  {
    key: 'ownerFirstName',
    label: t('ownerFirstName'),
    getValue: (item) => item.ownerData?.firstName || '',
  },
  {
    key: 'ownerLastName',
    label: t('ownerLastName'),
    getValue: (item) => item.ownerData?.lastName || '',
  },
  {
    key: 'ownerPhoneNumber',
    label: t('ownerPhoneNumber'),
    getValue: (item) => item.ownerData?.phoneNumber || '',
  },
  {
    key: 'contactPreferences',
    label: t('contactPreferences'),
    getValue: (item) => item.ownerData?.contactPreferences || '',
  },
  {
    key: 'locationPreferences',
    label: t('locationPreferences'),
    getValue: (item) => item.ownerData?.locationPreferences || '',
  },

  // --- Donor Data ---
  {
    key: 'donorName',
    label: t('donorName'),
    getValue: (item) => item.donorData?.name || '',
  },
  {
    key: 'donorAge',
    label: t('donorAge'),
    getValue: (item) => formatSafeValue(item.donorData?.age, ''),
  },
  {
    key: 'donorSpecies',
    label: t('donorSpecies'),
    getValue: (item) => item.donorData?.species || '',
  },
  {
    key: 'donorGender',
    label: t('donorGender'),
    getValue: (item) => item.donorData?.gender || '',
  },
  {
    key: 'donorWeight',
    label: t('donorWeight'),
    getValue: (item) => formatSafeValue(item.donorData?.weight, ''),
  },
  {
    key: 'donorLocation',
    label: t('donorLocation'),
    getValue: (item) => item.donorData?.location || '',
  },
  {
    key: 'neutered',
    label: t('neutered'),
    getValue: (item) => formatSafeValue(item.donorData?.neutered, ''),
  },
  {
    key: 'hasTransfusion',
    label: t('hasTransfusion'),
    getValue: (item) => formatSafeValue(item.donorData?.hasTransfusion, ''),
  },
  {
    key: 'takeMedications',
    label: t('takeMedications'),
    getValue: (item) => formatSafeValue(item.donorData?.takeMedications, ''),
  },
  {
    key: 'medicationCourse',
    label: t('medicationCourse'),
    getValue: (item) => item.donorData?.medicationCourse || '',
  },
  {
    key: 'primaryVeterinarian',
    label: t('primaryVeterinarian'),
    getValue: (item) => item.donorData?.primaryVeterinarian || '',
  },
  {
    key: 'hasMicrochip',
    label: t('hasMicrochip'),
    getValue: (item) => formatSafeValue(item.donorData?.hasMicrochip, ''),
  },
  {
    key: 'microchipNumber',
    label: t('microchipNumber'),
    getValue: (item) => item.donorData?.microchipNumber || '',
  },
  {
    key: 'distinguishableMarks',
    label: t('distinguishableMarks'),
    getValue: (item) => item.donorData?.distinguishableMarks || '',
  },
  {
    key: 'hasHeartMurmur',
    label: t('hasHeartMurmur'),
    getValue: (item) => formatSafeValue(item.donorData?.hasHeartMurmur, ''),
  },
];
